// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Modal, Input } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons/lib";

const { confirm } = Modal;

export function showConfirm(
  title: string,
  onOk?: (reason?: string) => void,
  onCancel?: () => void,
  t?: (valueToTranslate: string) => string,
  reason?: string,
  okLabel = "Confirmer",
  cancelLabel = "Annuler"
) {
  let reasonTo: string | undefined = undefined;
  confirm({
    title: title,
    icon: <QuestionCircleOutlined />,
    okText: okLabel,
    cancelText: cancelLabel,
    content: reason && (
      <Input
        placeholder={
          t
            ? reason === "unpublish"
              ? t("news_list.table.confirmation.reasonUnpublishPlaceholder")
              : t("news_list.table.confirmation.reasonPublishPlaceholder")
            : ""
        }
        onChange={e => {
          reasonTo = e.target.value;
        }}
      />
    ),
    centered: true,
    onOk() {
      onOk && (reasonTo ? onOk(reasonTo) : onOk());
    },
    onCancel() {
      onCancel && onCancel();
    }
  });
}
